import { useState, useEffect, useCallback } from 'react';
import { profileService } from '@/services/profileService';
import type { DriverProfile } from '@/types';
import { useUnifiedAuth } from '@/contexts/UnifiedAuthContext';

export function useProfile() {
  const { user } = useUnifiedAuth();
  const [profile, setProfile] = useState<DriverProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    if (!user) { setLoading(false); return; }
    try {
      setLoading(true);
      const data = await profileService.get();
      setProfile(data);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error loading profile');
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { fetch(); }, [fetch]);

  const update = useCallback(async (updates: Partial<DriverProfile>) => {
    const data = await profileService.update(updates);
    setProfile(data);
    return data;
  }, []);

  return { profile, loading, error, refetch: fetch, update };
}
